module.exports = __webpack_public_path__ + "static/media/table-delete-ic.f18d4832.svg";